import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ModalController, PopoverController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { ProcesoDesempenoService } from "src/app/service/modulo-desempeno/proceso-desempeno.service";
import { ProcessSummary } from "src/app/service/modulo-desempeno/proceso-desempeno.model";

/**
 * Panel flotante que se abre desde el item "Objetivos" del menú principal cuando
 * el usuario está en la plataforma de Desempeño. Lista los procesos a los que el
 * usuario tiene acceso usando {@link ProcesoDesempenioCardComponent}; al elegir
 * uno registra el proceso en contexto y navega a su detalle
 * (`performance/proceso/:id`).
 *
 * Quien lo presenta es {@link PerformanceProcessSelectionService}, que ya resolvió
 * la lista para decidir si vale la pena abrirlo —con un solo proceso entra directo
 * y este componente ni se monta— y se la pasa en {@link preloadedProcesses}.
 */
@Component({
	selector: "app-performance-objectives-popover",
	templateUrl: "./performance-objectives-popover.component.html",
	styleUrls: ["./performance-objectives-popover.component.scss"],
})
export class PerformanceObjectivesPopoverComponent implements OnInit, OnDestroy {
	/**
	 * Procesos ya cargados por quien abre el overlay. Un arreglo vacío también
	 * cuenta como cargado (el usuario no tiene ninguno); `null` significa que nadie
	 * los precargó y el componente los pide por su cuenta.
	 */
	@Input() preloadedProcesses: ProcessSummary[] | null = null;

	processes: ProcessSummary[] = [];
	loading = true;

	private processesSub?: Subscription;

	constructor(
		private procesoService: ProcesoDesempenoService,
		private popoverController: PopoverController,
		private modalController: ModalController,
	) {}

	ngOnInit() {
		if (this.preloadedProcesses) {
			this.processes = this.preloadedProcesses;
			this.loading = false;
			return;
		}

		this.processesSub = this.procesoService.getProcessSummaries().subscribe((processes) => {
			this.processes = processes;
			this.loading = false;
		});
	}

	ngOnDestroy() {
		this.processesSub?.unsubscribe();
	}

	/** Registra el proceso elegido, cierra el overlay y entra a su detalle. */
	select(process: ProcessSummary) {
		this.dismissOverlay();
		this.procesoService.enterProcess(process);
	}

	/**
	 * Cierra el overlay que contiene este componente, sea popover (desktop, anclado
	 * al header) o sheet modal (mobile, desde el footer).
	 */
	private async dismissOverlay() {
		const modal = await this.modalController.getTop();
		if (modal) {
			await modal.dismiss();
			return;
		}
		const popover = await this.popoverController.getTop();
		if (popover) await popover.dismiss();
	}
}
